module.exports = __webpack_public_path__ + "static/img/coins.67df30a5.png";